const indexItems = [
  { title: '久久视频专区', desc: '热播剧集、电影大片、综艺娱乐一站式入口，更新快画质好', tag: '热门', icon: 'ri-fire-fill' },
  { title: '芒果视频导航', desc: '独家综艺、自制剧集、纪录片频道，会员精彩内容一网打尽', tag: '推荐', icon: 'ri-thumb-up-line' },
  { title: '97视频入口', desc: '年轻化视频平台，精准推荐算法，发现你喜欢的视频内容', tag: '新锐', icon: 'ri-rocket-line' },
  { title: '丝瓜视频合集', desc: '电影、剧集、动漫、亲子内容全覆盖，适合全家一起看', tag: '全品类', icon: 'ri-apps-line' },
  { title: '蓝莓高清影院', desc: '超清画质专区，支持多码率自适应播放，观影体验出众', tag: '高清', icon: 'ri-4k-line' },
  { title: '91经典片库', desc: '运营多年积累大量经典影视，港片、好莱坞经典一应俱全', tag: '经典', icon: 'ri-vip-crown-line' },
  { title: '糖心特色内容', desc: '个性化推荐与社区互动，发现小众优质内容的不二之选', tag: '特色', icon: 'ri-heart-line' },
  { title: '黑桃视频速递', desc: '新兴视频平台，界面时尚内容新颖，年轻用户的新选择', tag: '新站', icon: 'ri-flashlight-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            平台导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            视频平台分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按平台特色分类整理，帮助您快速找到最适合的在线视频网站
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-accent-300 transition-all group cursor-pointer"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-100 transition-colors">
                  <i className={`${item.icon} text-accent-500 text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-bold text-foreground-900 group-hover:text-accent-500 transition-colors truncate">{item.title}</h3>
                    <span className="inline-block px-2 py-0.5 rounded-md bg-primary-100 text-primary-600 text-xs font-medium whitespace-nowrap flex-shrink-0">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}